import { apiGet, apiPost, apiPut } from '../../api/index';
import { urlExamReviewRequests } from '../../api/urls';

export function createExamReviewRequest(payload, callback) {
  return apiPost(urlExamReviewRequests, payload)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function getExamReviewRequestsByExam(examenId, callback) {
  return apiGet(`${urlExamReviewRequests}/by-exam/${examenId}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function updateExamReviewRequestStatus(id, payload, callback) {
  return apiPut(urlExamReviewRequests, `${id}/status`, payload)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function resolveExamReviewRequest(id, payload, callback) {
  return apiPut(urlExamReviewRequests, `${id}/resolve`, payload)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function getMyExamReviewRequests(examenId, callback) {
  const query = examenId ? `?examenId=${examenId}` : '';
  return apiGet(`${urlExamReviewRequests}/my${query}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}
